/* One shared entrance-reveal observer for every main-content section.
   Contract (motion-design skill): one threshold, one distance, one duration
   site-wide; fire once then unobserve; reveal the section's content layer;
   reduced-motion and no-JS see the page painted (the hidden state only
   exists once this file has run). Opt-out: data-no-reveal on the section's
   wrapper for bands that animate their own content. */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  if (document.body.classList.contains('shopify-design-mode')) return;

  var sections = document.querySelectorAll('#MainContent .shopify-section');
  if (!sections.length) return;

  var targets = [];
  sections.forEach(function (section) {
    if (section.hasAttribute('data-no-reveal')) return;
    var inner = section.firstElementChild;
    if (!inner) return;
    /* Above-the-fold content must not wait (≤300ms rule): sections already
       in view at setup get the class pre-transitioned, no entrance. */
    var rect = section.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.6 && rect.bottom > 0) {
      inner.classList.add('motion-reveal', 'motion-in');
      return;
    }
    inner.classList.add('motion-reveal');
    targets.push(section);
  });
  if (!targets.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var tallBand = entry.boundingClientRect.height > window.innerHeight * 0.7;
        if (entry.intersectionRatio >= 0.22 || tallBand) {
          entry.target.firstElementChild.classList.add('motion-in');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: [0, 0.22] }
  );
  targets.forEach(function (t) { observer.observe(t); });

  /* Safety net: anything still hidden when the page is about to be printed
     or restored from bfcache paints immediately. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('.motion-reveal:not(.motion-in)').forEach(function (el) {
      el.classList.add('motion-in');
    });
  });
})();
